import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class DrugClassService extends ConfigurationService {

    public modelPath = 'pharmacy/drug_classes';

    getDTColumns () {
        const self = this;
        return [{
            name: 'drug_class_id',
            title: 'Drug Class Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'drug_class_id'
        }, {
            name: 'drug_name',
            title: 'Drug Name',
            data: 'drug_name'
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-drug-class')) {
                    return `<div class="custom-control custom-checkbox">
						<input class="custom-control-input" data-modelPk="checkbox_${full.drug_class_id}" id="checkbox_${full.drug_class_id}" type="checkbox" />
						<label class="custom-control-label" for="checkbox_${full.drug_class_id}"></label>
					</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
				</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-drug-class')) {
                    return `<a id="${full.drug_class_id}" class="btn btn-secondary">
						<i data-modelPk="${full.drug_class_id}"  class="icon-pencil"></i>
					</a>`;
                }
                return '';
            }
        }];
    }
}
